export function moreThanOne(value) {
  return value?.length > 1
}
